import { Injectable, isDevMode } from '@angular/core';
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  Translation,
} from '@ngx-translate/core';

// Fallback de claves faltantes (contrato QBRAIN-433 / ADR-003):
// devuelve el valor del idioma base `es`; nunca muestra la key cruda al usuario.
const BASE_LANG = 'es';

@Injectable()
export class EsFallbackMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams): Translation {
    const { key, translateService } = params;

    if (isDevMode()) {
      // Log de claves faltantes en desarrollo (contrato).
      console.warn(`[i18n] Missing translation key: ${key}`);
    }

    // Las claves son namespaced (`module.section.element`) y ngx-translate las
    // guarda anidadas, así que se camina la ruta por puntos en vez de un acceso
    // plano `[key]` (que devolvería undefined para claves con punto).
    const baseTranslations = translateService.translations?.[BASE_LANG];
    const baseValue = key
      .split('.')
      .reduce<unknown>(
        (acc, part) =>
          acc !== null && acc !== undefined ? (acc as Record<string, unknown>)[part] : undefined,
        baseTranslations
      );
    if (baseValue !== undefined && baseValue !== null) {
      return baseValue as Translation;
    }

    return key;
  }
}
